import React from 'react';
import { Alert, Box, Typography } from '@mui/material';

const RolesAnywhereTab: React.FC = () => (
    <Box>
        <Typography variant='h5' sx={{ mb: 2 }}>IAM Roles Anywhere</Typography>
        <Alert severity='info'>
            Roles Anywhere end-entity cert management lands with HOME-154. The same
            home CA will sign these certs; the data model already supports `kind: roles-anywhere`.
        </Alert>
    </Box>
);

export default RolesAnywhereTab;
